(function () {
  'use strict';

  var SELECTOR = '.trustmarks-new .tm-carousel-outer';
  var DEFAULT_MIN_SCALE = 0.72;
  var DEFAULT_MAX_SCALE = 1.12;
  var CURVE = 1.8;
  var DEFAULT_SCALE_ZONE = 0.42;
  var PIXELS_PER_SECOND = 108;
  var MIN_SAFE_SCALE = 0.6;

  function getNumericCssVar(styles, name, fallback) {
    var value = parseFloat(styles.getPropertyValue(name));

    return Number.isFinite(value) ? value : fallback;
  }

  function initCarousel(outer) {
    if (!outer || outer.dataset.tmScaleInit === 'true') return;

    var track = outer.querySelector('.tm-carousel-track');
    var originalItems = Array.prototype.slice.call(outer.querySelectorAll('.tm-carousel-item'));
    var items = [];
    var scaleMin = DEFAULT_MIN_SCALE;
    var scaleMax = DEFAULT_MAX_SCALE;
    var scaleZone = DEFAULT_SCALE_ZONE;
    var fadeWidth = 0;
    var fitPadding = 0;

    if (!track || !originalItems.length) return;

    outer.dataset.tmScaleInit = 'true';

    function readLayoutVars() {
      var styles = window.getComputedStyle(outer);

      scaleMin = getNumericCssVar(styles, '--tm-scale-min', DEFAULT_MIN_SCALE);
      scaleMax = getNumericCssVar(styles, '--tm-scale-max', DEFAULT_MAX_SCALE);
      scaleZone = getNumericCssVar(styles, '--tm-scale-zone', DEFAULT_SCALE_ZONE);
      fadeWidth = getNumericCssVar(styles, '--tm-edge-fade', 0);
      fitPadding = getNumericCssVar(styles, '--tm-fit-padding', 0);
    }

    function setupLoop() {
      if (track.dataset.tmLoopReady !== 'true') {
        var fragment = document.createDocumentFragment();

        originalItems.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          fragment.appendChild(clone);
        });

        track.appendChild(fragment);
        track.dataset.tmLoopReady = 'true';
      }

      readLayoutVars();
      items = Array.prototype.slice.call(track.querySelectorAll('.tm-carousel-item'));

      var firstSetWidth = 0;
      originalItems.forEach(function (item) {
        firstSetWidth += item.offsetWidth;
      });

      if (originalItems.length > 1) {
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        firstSetWidth += gap * (originalItems.length - 1);
      }

      if (firstSetWidth > 0) {
        track.style.setProperty('--tm-loop-distance', firstSetWidth + 'px');
        track.style.setProperty('--tm-loop-duration', (firstSetWidth / PIXELS_PER_SECOND).toFixed(2) + 's');
      }
    }

    function updateScales() {
      var outerRect = outer.getBoundingClientRect();
      var centreX = outerRect.left + (outerRect.width / 2);
      var maxDist = outerRect.width * scaleZone;
      var visibleWidth = Math.max(outerRect.width - (fadeWidth * 2) - (fitPadding * 2), 1);
      var visibleHeight = Math.max(outer.clientHeight - (fitPadding * 2), 1);

      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var baseWidth = item.offsetWidth || rect.width || 1;
        var baseHeight = item.offsetHeight || rect.height || 1;
        var itemCentreX = rect.left + (rect.width / 2);
        var dist = Math.abs(itemCentreX - centreX);
        var progress = maxDist > 0 ? Math.max(0, 1 - (dist / maxDist)) : 0;
        var eased = Math.pow(progress, CURVE);
        var desiredScale = scaleMin + ((scaleMax - scaleMin) * eased);
        var widthCap = visibleWidth / baseWidth;
        var heightCap = visibleHeight / baseHeight;
        var safeScale = Math.min(desiredScale, widthCap, heightCap);

        if (!Number.isFinite(safeScale) || safeScale <= 0) {
          safeScale = desiredScale;
        }

        safeScale = Math.max(MIN_SAFE_SCALE, safeScale);

        item.style.setProperty('--tm-scale', safeScale.toFixed(4));
        item.style.zIndex = String(Math.round(safeScale * 100));
      });

      requestAnimationFrame(updateScales);
    }

    setupLoop();
    requestAnimationFrame(updateScales);
    window.addEventListener('resize', setupLoop);
  }

  function initAll() {
    var carousels = document.querySelectorAll(SELECTOR);
    if (!carousels.length) return;
    Array.prototype.forEach.call(carousels, initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);
}());
